module.exports = __webpack_public_path__ + "media/lobby_normal4.034db57b.mp3";